<div class="ttmodal" *ngIf="isCrack==false && componentId>0">
  <!-- <div class="ttmodal__header">
     
     
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div> -->
<div style="display: flex; flex-direction: row; justify-content: space-between;">
  <div style="display: flex; flex-direction: column;">
    <span class="ttmodal__title" style="font-size: initial;font-weight: bold;">Component: {{CompName | translate | async}} </span>
    <span class="ttmodal__title" style="font-size: initial;font-weight: bold;"> Obs Point : {{ObsName | translate | async}} </span>
  </div>
  <div>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" style="cursor: pointer;">close</i>
  </div>
</div>

  <div class="ttmodal__footer" style="height: 660px;overflow-y: auto; margin-top: 10px !important;" *ngIf="historyList!=null">
    
        <table  class="table table--full-width table--striped table--hover">
          <thead>
            <tr>

              <th style="padding: 0px 15px" >Date</th>
              <th style="padding: 0px 15px" >SMU</th>
              <th style="padding: 0px 15px" >Action</th>
              <th style="padding: 0px 15px;width: 10%;" >% Worn</th>
              <th style="padding: 0px 15px;width: 12%;" >Actual Inspection Reading</th>
              <th style="padding: 0px 15px" >CMU</th>
              <th style="padding: 0px 15px" >Residual</th>
              <th style="padding: 0px 15px" >UnSch. Time</th>
              <th style="padding: 0px 15px" >Cost</th>
              <th style="padding: 0px 15px" >Comment</th>
             
            </tr>
          </thead>
          <tbody>
         
              <ng-container *ngFor="let obs of historyList">
                <tr>
                 <td>{{obs.actionDate |date: 'dd MMM yyyy'}}</td>
                 <td style="max-width: 250px;">{{obs.SMU}}</td>
                 <td style="max-width: 250px;">{{obs.Action}}</td>

                 <td *ngIf="obs.Worn!=null"><span  class="Eval-{{ obs.Worn | wornPercentageToEval}}"
                  style="margin-right: 7px;padding: 7px 21px;">
                  <div>{{obs.Worn?.toFixed(1)}}%</div>
                </span></td>
                <td *ngIf="obs.Worn==null"><span  class="Eval-U"
                  style="margin-right: 7px;padding: 7px 21px;">
                  <div>{{'N/A'}}</div>
                </span></td>
                <td>{{obs.Reading}}</td>
                 <td>{{obs.CMU}}</td>
                 <td>{{ getValue(obs) }}</td>
                 <!-- <td>{{obs.Worn?.toFixed(1)}} >=100?0:{{obs.Residual}}</td> -->
                 <td>{{obs.downTime}}</td>
                 <td>{{obs.Cost}}</td>
                 <td>{{obs.Comment}}</td>
                 

                </tr>
            </ng-container>
            
           
              
  
          </tbody>
      </table>
  </div>
  
</div>

<div class="ttmodal" *ngIf="isCrack==true && componentId>0">

  <div style="display: flex; flex-direction: row; justify-content: space-between;">
    <div style="display: flex; flex-direction: column;">
      <span class="ttmodal__title" style="font-size: initial;font-weight: bold;">Component: {{CompName | translate | async}} </span>
      <span class="ttmodal__title" style="font-size: initial;font-weight: bold;"> Obs Point : {{ObsName | translate | async}} </span>
    </div>
    <div>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()" style="cursor: pointer;">close</i>
    </div>
  </div>
  <div class="ttmodal__footer" style="height: 660px; overflow-y: auto; margin-top: 10px !important;" *ngIf="historyList!=null">
    
        <table  class="table table--full-width table--striped table--hover nowrap_text">
          <thead>
            <tr>
              <th style="padding: 0px 15px" >Action Date</th>
              <th style="padding: 0px 15px" >SMU</th>
              <th style="padding: 0px 15px" >Action</th>
              <th style="padding: 0px 15px" >Start XY</th>
              <th style="padding: 0px 15px" >End XY</th>
              <th style="padding: 0px 15px" >Length</th>
              <th style="padding: 0px 15px" >Crack Severity</th>
              <th style="padding: 0px 15px" >Max L</th>
              <th style="padding: 0px 15px;width: 10%;" >% Worn</th>
              <th style="padding: 0px 15px" >CMU</th>
              <th style="padding: 0px 15px" >Residual</th>
              <th style="padding: 0px 15px" >Rate</th>
              <th style="padding: 0px 15px" >Status</th>
              <th style="padding: 0px 15px" >UnSch. Time</th>
              <th style="padding: 0px 15px" >Cost</th>
              <th style="padding: 0px 15px" >Comment</th>
              <th style="padding: 0px 15px" >Images</th>
            </tr>
          </thead>
          <tbody>
         
              <ng-container *ngFor="let obs of historyList">
                <tr>
                 <td>{{obs.actionDate |date: 'dd MMM yyyy'}}</td>
                 <td style="max-width: 250px;">{{obs.SMU}}</td>
                 <td style="max-width: 250px;">{{obs.Action}}</td>
                 <td style="max-width: 250px;">{{obs.stratX}},{{obs.stratY}}</td>
                 <td style="max-width: 250px;">{{obs.endX}},{{obs.endY}}</td>
                 <td style="max-width: 250px;">{{obs.cracklength}}</td>
                 <!-- <td style="max-width: 250px;">{{obs.CrackSeverity}}</td> -->
                 <td style="max-width: 250px; cursor: pointer;" [matTooltip]="obs.CrackSeverity" matTooltipPosition="above">
                  {{ obs.CrackSeverity?.length > 20 ? (obs.CrackSeverity | slice:0:20) + '...' : obs.CrackSeverity }}
                </td>
                 <td style="max-width: 250px;">{{obs.maxL}}</td>
                 <td *ngIf="obs.Worn!=null"><span  class="Eval-{{ obs.Worn | wornPercentageToEval}}"
                  style="margin-right: 7px;padding: 7px 21px;">
                  <div>{{obs.Worn?.toFixed(1)}}%</div>
                </span></td>
                <td *ngIf="obs.Worn==null"><span  class="Eval-U"
                  style="margin-right: 7px;padding: 7px 21px;">
                  <div>{{'N/A'}}</div>
                </span></td>
                 <td>{{obs.CMU}}</td>
                 <td>{{ getValue(obs) }}</td>
                 <td *ngIf="obs.CMU>0 && obs.cracklength>0"> {{obs.Rate}} Hrs/mm</td>
                 <td *ngIf="obs.CMU<=0 || obs.cracklength==0"> -</td>
                 <!--<td *ngIf="obs.CMU<0 "> 0</td>-->
                 <td>{{obs.Status}}</td>
                 <td>{{obs.downTime}}</td>
                 <td>{{obs.Cost}}</td>
                 <td>{{obs.Comment==null ||obs.Comment=="" ?"-":obs.Comment}}</td>
                 <td style="display: flex;"> 
                  <div *ngIf="obs.Id>0">
                   <span style="font-size: initial;font-weight: bold;margin-right: 4px; margin-top: 4px;">{{obs.CrackObPointImagesVM != null ? obs.CrackObPointImagesVM.length : 0}} </span>
                    <ng-container *ngIf="obs.CrackObPointImagesVM != null && obs.CrackObPointImagesVM.length==0">
                      <i class="material-icons button__icon" style="cursor: pointer;" >image</i>                                                                     
                    </ng-container>

                    <ng-container *ngIf="obs.CrackObPointImagesVM != null && obs.CrackObPointImagesVM.length>0">
                    <ng-container *ngFor="let photo of obs.CrackObPointImagesVM">
                      <i class="material-icons button__icon" style="cursor: pointer;color: green;" (click)="openViewPhoto(photo)" >image</i>                                                                     
                    </ng-container> 
                  </ng-container>

                    <div (click)="fileInput.click()" title="{{'Add photo' | translate | async}}">
                      <i class="material-icons button__icon" style="cursor: pointer;" >add</i>
                          <input style="display: none;" type="file"
                                 #fileInput
                                 (change)="onSelectPhoto($event, obs.Action, obs.Id,obs.ObPointHxId)">
                    </div>   
                    </div>                                                   
                 </td>
                </tr>
            </ng-container>                                   
          </tbody>
      </table>
  </div>
  
</div>

<div class="ttmodal" *ngIf="implementId>0">

  <div style="display: flex; flex-direction: row; justify-content: space-between;">
    <div style="display: flex; flex-direction: column;">
      <span class="ttmodal__title" style="font-size: initial;font-weight: bold;">Replace And Repair Action </span>
      <span class="ttmodal__title" style="font-size: initial;font-weight: bold;"> Date : {{ActionDate  |date: 'dd MMM yyyy'}} </span>
    </div>
    <div>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()" style="cursor: pointer;">close</i>
    </div>
  </div>
  <div class="ttmodal__footer" style="height: 360px;overflow-y: auto;" *ngIf="historyList!=null">
    
    <table  class="table table--full-width table--striped table--hover">
      <thead>
        <tr>

          <th style="padding: 0px 24px" >Date</th>
          <th style="padding: 0px 24px" >Component</th>
          <th style="padding: 0px 24px" >SMU</th>
          <th style="padding: 0px 24px" >UnSch. Time</th>
          <th style="padding: 0px 24px" >Cost</th>
          <th style="padding: 0px 24px" >Comment</th>
        </tr>
      </thead>
      <tbody>
     
          <ng-container *ngFor="let obs of historyList">
            <tr>
             <td>{{obs.actionDate |date: 'dd MMM yyyy'}}</td>
             <td style="max-width: 250px;">{{obs.Action}}</td>
             <td>{{obs.SMU}}</td>
             <td>{{obs.downTime}}</td>
             <td>{{obs.Cost}}</td>
             <td>{{obs.Comment}}</td>

            </tr>
        </ng-container>
        
       
          

      </tbody>
  </table>
  </div>
  
</div>
